<template>
  <header>
    <nav>
      <router-link
        :to="activeUserRole === 'Администратор' ? '/admin-panel/admins' : '/'"
        ><img
          draggable="false"
          :src="require('@/assets/img/logo.svg')"
          alt="Газпром"
          class="logo"
      /></router-link>

      <router-link v-if="backLink" :to="backLink"
        ><svgicon
          icon="big_arrow"
          width="16px"
          style="margin: 0 24px"
        ></svgicon>
        Назад
      </router-link>
    </nav>

    <div class="header__right">
      <div class="version">2.0.29</div>

      <div class="vl"></div>

      <div class="time">
        <svgicon icon="clock" width="12px"></svgicon>
        <span>{{ new Date() | simpleDate }}</span>
      </div>

      <div class="vl"></div>

      <div class="role">
        <small>Роль:</small>
        <p>{{ activeUserRole }}</p>
      </div>

      <div class="vl"></div>

      <AccountBadge :events="events" :user="activeUser" selecteble />
    </div>
  </header>
</template>

<script>
import AccountBadge from "@/components/AccountBadge.vue";
import Auth from "@/utils/auth.js";
import { mapState, mapGetters } from "vuex";

export default {
  components: { AccountBadge },
  data() {
    return {
      events: [
        {
          id: 1,
          event: () => {
            const routeData = {
              params: { id: this.activeUser.id, type: "users" },
            };

            if (this.$route.name !== "User") routeData.name = "User";
            if (this.$route.params?.id !== routeData.params.id) {
              this.$router.push(routeData);
            }
          },
          title: "Мой профиль",
          icon: "user",
        },
        { id: 2, event: this.logout, title: "Выход", icon: "quit" },
      ],
      references: [
        "Cards",
        "ReturnReasons",
        "Contracts",
        "Filiations",
        "Osr",
        "Departments",
        "Logisticians",
        "Passengers",
        "Admins",
        "Users",
      ],
    };
  },
  computed: {
    ...mapState("users", ["activeUser", "activeUserRole"]),
    ...mapGetters("users", ["activeUserRole"]),
    backLink() {
      let isReferences = false;
      this.references.some((item) => {
        if (item === this.$route.name) isReferences = true;
      });
      if (isReferences) {
        return "/orders";
      } else if (this.$route.name === "TicketsInfo") {
        return "/order/read/" + this.$route.params.id;
      } else {
        return (
          this.$route.meta.breadcrumb?.to || this.$route.params.backLink || ""
        );
      }
    },
  },
  methods: {
    logout() {
      Auth.logout();
      this.$router.push({ name: "Login", params: { withoutConfrim: true } });
    },
  },
};
</script>

<style scoped lang="scss">
header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding: 0 48px;
  border-bottom: 1px solid rgba(0, 65, 102, 0.2);
  margin-bottom: 75px;
  z-index: 100;
  position: relative;

  nav {
    display: flex;
    align-items: center;

    .logo {
      max-width: 100px;
    }
  }
}

.header__right {
  display: flex;
  align-items: center;

  .time {
    color: $light-black;
    fill: currentColor;
    display: flex;
    align-items: center;
    svg {
      margin-right: 4px;
    }
  }

  .version {
    color: #2e5c78;
  }

  .vl {
    display: block;
    border-left: 1px solid $gray;
    height: 36px;
    margin-right: 20px;
    margin-left: 20px;
  }

  .role {
    text-align: center;

    small {
      color: #97b2c4;
      line-height: 120%;
    }
    p {
      font-size: 16px;
      line-height: 120%;
      color: $light-black;
    }
  }
}
</style>
